// extracted by mini-css-extract-plugin
export default {"summary":"TaskProjectPage_summary__VgG4F","titlebox":"TaskProjectPage_titlebox__xLuN9","title":"TaskProjectPage_title__au1jV"};